
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderPanel from './components/HeaderPanel/index.vue'
import StationeryBag from './components/StationeryBag/index.vue'
import StationeryAddress from './components/StationeryAddress/index.vue'
import CategoryPanel from './components/CategoryPanel/index.vue'
import StationeryBagModal, { type ModalInfo } from './components/StationeryBagModal/index.vue'
import StationeryAddressModal from './components/StationeryAddressModal/index.vue'
import ShowQrcodePop from './components/ShowQrcodePop/index.vue'
import { ClickEvent } from '@xt/client/types/home.d'
import { StationeryJSONData } from '@xt/client/types/stationery.d'
import { $service } from '@xt/client/experimental/request/service'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import { type OpenMiniProgramOptionType } from '@xt/client/utils/mini'
import { EnumOpenMiniProgramType } from '@xt/client/enums/mini'

@Observer
@Component({
  components: {
    HeaderPanel,
    StationeryBag,
    StationeryAddress,
    CategoryPanel,
    StationeryBagModal,
    StationeryAddressModal,
    ShowQrcodePop
  },
  async asyncData(ctx) {
    const [err, JsonData] = await $service<StationeryJSONData>({
      method: 'GET',
      url: '/mocks/stationery-web.json',
      baseURL: ctx.store.$global.static
    })

    if (err) throw err

    return {
      JsonData
    }
  }
})
export default class StationeryPage extends Mixins(MixinsHomeClick) {
  JsonData: StationeryJSONData

  modalVisible: boolean = false
  modalInfo: ModalInfo | null = null

  qrcodeVisible: boolean = false
  qrcodeUrl: string = ''
  qrcodeGeneratorParams:
    | {
        path: string
        alias: string
      }
    | {} = {}
  // view: 扫码查看， buy: 扫码购买
  qrcodeScanType: 'view' | 'buy' = 'buy'

  addressModalVisible: boolean = false

  openMiniProgramOpt: OpenMiniProgramOptionType | null = null

  get EnumOpenMiniProgramType() {
    return EnumOpenMiniProgramType
  }

  showStationeryAddressModal(show: boolean) {
    this.addressModalVisible = show
  }

  onQrcodePopClosed() {
    // 清除上一次点击的数据
    this.qrcodeUrl = ''
    this.qrcodeGeneratorParams = {}
  }

  // banner点击事件
  handleClickEvent(item: { event?: ClickEvent }) {
    if (!item.event) return

    this.onClickEvent(item.event)
  }

  // 拉起二维码弹窗 - qrcodeUrl形式
  handleShowQrcode(data: { item: { event?: ClickEvent }; type?: 'view' | 'buy' }) {
    const { item, type = 'buy' } = data
    if (item.event && item.event.type === 'jump-mini') {
      this.qrcodeUrl = item.event.qrcode || ''
      this.qrcodeScanType = type
      this.openMiniProgramOpt = {
        path: item.event.path,
        miniProgrmType: item.event.miniProgramType
      }
      this.showQrcodePop(true)
      return
    }
  }

  // 拉起二维码弹窗 - qrcodeGeneratorParams形式
  handleShowQrcodeByParams(item: { path: string; alias: string }) {
    this.qrcodeGeneratorParams = {
      ...item
    }

    this.openMiniProgramOpt = {
      miniProgrmType: EnumOpenMiniProgramType.Wenfang
    }
    this.qrcodeScanType = 'buy'
    this.showQrcodePop(true)
  }

  // 拉起文房包详情
  onOpenModal(info: ModalInfo): void {
    this.modalInfo = { ...info }
    this.showStationeryBagModal(true)
  }

  // 显示/隐藏二维码弹窗
  showQrcodePop(show: boolean): void {
    this.qrcodeVisible = show
  }

  // 显示/隐藏文房包弹窗
  showStationeryBagModal(show: boolean): void {
    this.modalVisible = show
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
